exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-dialog-title {\n  margin: 0 0 10px;\n  display: block;\n}\n\n.mat-dialog-content {\n  border-top: 1px solid #e0d7d7;\n  border-bottom: 1px solid #e0d7d7;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/login.theprintlife.com/src/app/shared/confirmation-dialog/confirmation-dialog.component.css
// module id = ../../../../../src/app/shared/confirmation-dialog/confirmation-dialog.component.css
// module chunks = main